import React from "react";
import { colors } from "../../../../../../themes/Colors";

const OffenseHeader = () => {
  return (
    <div
      style={{
        width: "100%",
        height: 50,
        backgroundColor: colors.greenLight,
        display: "flex",
        alignItems: "center",
        fontWeight: "bold",
        fontSize: 12,
        color: colors.white,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.2,
        }}
      >
        <div style={{ marginLeft: 10 }}>OFFENSE REFERENCE</div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.2,
        }}
      >
        VEHICLE
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.2,
        }}
      >
        DESCRIPTION
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.2,
        }}
      >
        USER
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: 0.1,
        }}
      >
        ACTIONS
      </div>
    </div>
  );
};

export default OffenseHeader;
